import React from 'react';
import useSchemaStore from '../../store/schemaStore';

const Tablename = () => {
  const { tableName, updateTableName, resetAll, loadLastFromMysql } = useSchemaStore();

  return (
    <>
      <div className="form-group">
        <label>
          <b>Table Name</b>
        </label>
        <input
          type="text"
          className="form-control"
          placeholder="Table Name"
          value={tableName}
          onChange={(e) => updateTableName(e.target.value)}
        />
      </div>
      <button className="resetBtn btn btn-primary ms-2" onClick={resetAll}>
        Reset All
      </button>
      <button className="resetBtn btn btn-primary ms-2" onClick={loadLastFromMysql}>
        Load Last
      </button>
    </>
  );
};

export default Tablename;